import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RaceRankingStandingsComponent } from './race/race-ranking-standings/race-ranking-standings.component';
import { SeasonRankingStandingsComponent } from './season-ranking-standings/season-ranking-standings.component';
import { SeasonComponent } from './season.component';
import { SeasonRoutingModule } from './season-routing.module';
import { RacesComponent } from './races/races.component';
import { RacesService } from './races/races.service';
import { RankingsService } from './rankings/rankings.service';
import { ResultComponent } from './results/result/result.component';
import { LaptimeRangeFilterPipe } from './results/result/laptime-range-filter.pipe';
import { LaptimeFilterPipe } from './results/result/laptime-filter.pipe';
import { ResultsFilterPipe } from './results/results-config/results-filter.pipe';
import { StandingFilterPipe } from './standings/standing-filter.pipe';
import { ResultsComponent } from './results/results.component';
import { RemoteResultsService } from './results/remote-results.service';
import { SpreadsheetService } from './results/spreadsheet.service';
import { ToUniqueResultIdPipe } from './results/result/to-unique-result-id.pipe';
import { AppCommonsModule } from '../app-commons/app-commons.module';
import { RaceComponent } from './race/race.component';
import { SettingsComponent } from './settings/settings.component';
import { SettingsService } from './settings/settings.service';
import { SeasonService } from './season.service';
import { SeasonPointsPipe } from './season-points.pipe';
import { RouterModule } from '@angular/router';
import { ActiveRaceService } from './race/active-race.service';
import { PositionToPointsPipe } from './standings/position-to-points.pipe';
import { IsResultWithinMicrotimeRangePipe } from './results/result/is-result-within-microtime.pipe';
import { RaceSyncProgressBarComponent } from './race-sync-progress-bar/race-sync-progress-bar.component';
import { Race$Resolver } from './race/race$.resolver';
import { RaceRankingComponent } from './race/race-ranking/race-ranking.component';
import { SeasonRankingsComponent } from './season-rankings/season-rankings.component';
import { Ranking$Resolver } from './rankings/ranking$.resolver';
import { RankingSelectorComponent } from './rankings/ranking-selector/ranking-selector.component';
import { ProgressIndicatorComponent } from './progress-indicator/progress-indicator.component';
import { DriverResultsChartComponent } from './results/driver-results-chart/driver-results-chart.component';
import { RaceSettingsComponent } from './race/race-settings/race-settings.component';
import { RaceRankingsComponent } from './race/race-rankings/race-rankings.component';
import { StartNumberChangeToolComponent } from './race/race-settings/start-number-change-tool/start-number-change-tool.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    SeasonRoutingModule,
    RouterModule
  ],
  declarations: [
    SeasonComponent,
    ResultsComponent,
    RaceRankingStandingsComponent,
    SeasonRankingStandingsComponent,
    RacesComponent,
    ResultComponent,
    LaptimeRangeFilterPipe,
    LaptimeFilterPipe,
    ResultsFilterPipe,
    StandingFilterPipe,
    ToUniqueResultIdPipe,
    RaceComponent,
    SettingsComponent,
    SeasonPointsPipe,
    PositionToPointsPipe,
    IsResultWithinMicrotimeRangePipe,
    RaceSyncProgressBarComponent,
    RaceRankingComponent,
    SeasonRankingsComponent,
    RankingSelectorComponent,
    ProgressIndicatorComponent,
    DriverResultsChartComponent,
    RaceSettingsComponent,
    RaceRankingsComponent,
    StartNumberChangeToolComponent
  ],
  exports: [
    ResultComponent,
    LaptimeFilterPipe,
    SeasonPointsPipe,
    PositionToPointsPipe,
    IsResultWithinMicrotimeRangePipe
  ],
  providers: [
    RankingsService,
    RacesService,
    LaptimeRangeFilterPipe,
    ResultsFilterPipe,
    StandingFilterPipe,
    ToUniqueResultIdPipe,
    RemoteResultsService,
    SpreadsheetService,
    SettingsService,
    SeasonPointsPipe,
    PositionToPointsPipe,
    IsResultWithinMicrotimeRangePipe,
    SeasonService,
    ActiveRaceService,
    Race$Resolver,
    Ranking$Resolver
  ]
})
export class SeasonModule { }
